import { CheckCircle2, User } from "lucide-react";
import { useTranslation } from "react-i18next";
import { DropdownMenuItem, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { getProfileDisplayName } from "@/lib/profileUtils";
import type { AssignableUser } from "./DefectCard.types";

interface DefectAssignableUserItemsProps {
  defectId: string;
  assignableUsers: AssignableUser[];
  assignedTo?: string | null;
  includeRemoveAssignment?: boolean;
  onAssign: (id: string, userId: string | null) => void;
}

export function DefectAssignableUserItems({
  defectId,
  assignableUsers,
  assignedTo,
  includeRemoveAssignment = false,
  onAssign,
}: DefectAssignableUserItemsProps) {
  const { t } = useTranslation();

  return (
    <>
      {includeRemoveAssignment && assignedTo && (
        <>
          <DropdownMenuItem onClick={() => onAssign(defectId, null)} className="text-warning">
            <User className="h-4 w-4 mr-2" />
            {t("defects.removeAssignment")}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
        </>
      )}
      {assignableUsers.map((assignUser) => (
        <DropdownMenuItem
          key={assignUser.user_id}
          onClick={() => onAssign(defectId, assignUser.user_id)}
          className={assignedTo === assignUser.user_id ? "bg-primary/10" : ""}
          data-sentry-mask
        >
          <User className="h-4 w-4 mr-2" />
          {getProfileDisplayName(assignUser)}
          {assignedTo === assignUser.user_id && (
            <CheckCircle2 className="h-3 w-3 ml-auto text-primary" />
          )}
        </DropdownMenuItem>
      ))}
    </>
  );
}
